module.exports = __webpack_public_path__ + "media/ubud/temple2-87589bfc.jpg";